const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgM2EyIDIgMCAwIDEgMiAydjJhMiAyIDAgMCAxLTIgMnYxMGEyIDIgMCAwIDEtMiAySDZhMiAyIDAgMCAxLTItMlY5YTIgMiAwIDAgMS0yLTJWNWEyIDIgMCAwIDEgMi0yaDE2em0tMiA2SDZ2MTBoMTJWOXptLTMgMXYySDl2LTJoNnptNS01SDR2MmgxNlY1eiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+Cg==";
export {
  M as default
};
//# sourceMappingURL=deleted-1cbbfa69.mjs.map
